import { isMandarinoCamp } from "@/helpers/customFeatures.ts";
import { ParcelObjectType } from "@/helpers/types/types.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { RootAttribute } from "@/stores/EngineStore/enums/RootAttribute.ts";
import { useMemo } from "react";
import { useShallow } from "zustand/react/shallow";

export const useValidateExtraOptionsStep = () => {
  const { rootAttributes, cartAccommodationItems } = useEngineStore(
    useShallow((state) => ({
      rootAttributes: state.rootAttributes,
      cartAccommodationItems: state.cartAccommodationItems,
    })),
  );
  const areDimensionsMandatory = rootAttributes[RootAttribute.ParcelVehiclePickerDimensionsMandatory];

  const areParcelVehicleDimensionsMissing = useMemo((): boolean => {
    if (areDimensionsMandatory) {
      const itemsWithMissingDimensions = cartAccommodationItems.filter(
        (item) => item.rateGroup.isParcel && !item.parcelObjectDimensions,
      );
      if (itemsWithMissingDimensions.length > 0) {
        return true;
      }
    }
    return false;
  }, [cartAccommodationItems, areDimensionsMandatory]);

  const areChildAgesMissing = useMemo(
    () => cartAccommodationItems.some((item) => item.children.some((child) => child.age === null)),
    [cartAccommodationItems],
  );

  const isCaravanMoverMissing = useMemo((): boolean => {
    if (!isMandarinoCamp()) return false;
    if (rootAttributes[RootAttribute.HideParcelVehiclePicker]) return false;
    return cartAccommodationItems.some(
      (item) =>
        item.rateGroup.isParcel &&
        item.parcelObjectType === ParcelObjectType.Caravan &&
        item.parcelObjectHasMover === undefined,
    );
  }, [cartAccommodationItems, rootAttributes]);

  return { areParcelVehicleDimensionsMissing, areChildAgesMissing, isCaravanMoverMissing };
};
